import { MktFooter } from '@playbooks/components/mkt/mkt-footer';
import { MktNav } from '@playbooks/components/mkt/mkt-nav';
import { MktPrefooter } from '@playbooks/components/mkt/mkt-prefooter';
import { Route } from '@playbooks/ui/components/route';
import { cn } from '@playbooks/ui/lib/utils';

const MktWrapper = ({ seo = null, children, className = '', prefooter = true, footer = true }) => {
	// Theme
	const rootClassName = cn('flex-column min-h-[100vh]', className);

	// Render
	return (
		<Route seo={seo} className={rootClassName}>
			<div className='fixed inset-x-0 top-0 z-10 pt-[env(safe-area-inset-top,0px)]'>
				<MktNav />
			</div>
			<main className='flex-column grow min-h-[100vh] pt-16 overflow-hidden w-full z-0'>{children}</main>
			{prefooter && <MktPrefooter />}
			{footer && <MktFooter />}
		</Route>
	);
};
export { MktWrapper };
